import _isFunction from 'lodash/isFunction';
export var isTagDeletable = function isTagDeletable(_ref) {
  var selectValue = _ref.selectValue,
    isSelectValueDeletable = _ref.isSelectValueDeletable,
    areTagsDeletable = _ref.areTagsDeletable;
  if (_isFunction(isSelectValueDeletable)) {
    return isSelectValueDeletable(selectValue);
  }
  return areTagsDeletable;
};